import React from "react";
import notify from "devextreme/ui/notify";
import Form, {
  SimpleItem,
  GroupItem,
  Label,
  EmptyItem,
  ButtonItem,
} from "devextreme-react/form";
import "devextreme-react/text-area";
import { Button } from "devextreme-react";
import uiInfo from "../../ui-info";
import {
  criarLancamentoDs,
  criarMotivoIsencaoIptuDs,
  criarAgentesRecebedoresDs,
} from "../../DataSources";
import {
  DataGrid,
  Column,
  Paging,
  Pager,
  Summary,
  TotalItem,
} from "devextreme-react/data-grid";
import {
  imprimirDam,
  imprimirAlvara,
  abrirLancamento,
} from "../../lancamentosUtils";
import api from "../../api-axios";
import ShowError from "../../AppServices";
import UserInfo from "../../UserInfo";
import Toolbar, { Item } from "devextreme-react/toolbar";
import { LoadIndicator } from "devextreme-react/load-indicator";
import pixIcon from "../../images/icons/pix.png";

export default class DetalheLanchamento extends React.Component {
  constructor(props) {
    super(props);
    this.lancamentos = criarLancamentoDs();
    this.motivosDs = criarMotivoIsencaoIptuDs();
    this.saidaProgramada = false;
    this.prefeituraId = UserInfo.getPrefeitura();
    this.lancamentoSequencial = this.props.match.params.id;
    this.state = {
      _uiModificarSituacao: { novaSituacao: "N" },
      locadIndicatorVisivel: 0,
      usaPix: true,
      pixOk: false,
      pixIgnorado: false
    };

    this.baixarParcela = this.baixarParcela.bind(this);
    this.excluirBaixa = this.excluirBaixa.bind(this);
    this.modificarSituacao = this.modificarSituacao.bind(this);
    this.editar = this.editar.bind(this);
    this.espelho = this.espelho.bind(this);
    this.dam = this.dam.bind(this);
    this.confirmarPix = this.confirmarPix.bind(this);
    this.documento = this.documento.bind(this);
    this.novaSituacaoAlterada = this.novaSituacaoAlterada.bind(this);
    this.atualizarTela = this.atualizarTela.bind(this);
    this.timeoutWait = this.timeoutWait.bind(this);

    this.enumSituacoes = [
      { id: "N", descricao: "Normal" },
      { id: "I", descricao: "Isento" },
      { id: "M", descricao: "Imune" },
    ];

    this.situcaoAtualOptions = {
      editorType: "dxSelectBox",
      searchEnabled: false,
      dataSource: this.enumSituacoes,
      valueExpr: "id",
      displayExpr: "descricao",
      readOnly: true,
    };

    this.situacaoOptions = {
      editorType: "dxSelectBox",
      searchEnabled: false,
      dataSource: this.enumSituacoes,
      valueExpr: "id",
      displayExpr: "descricao",
      placeholder: " ",
      onValueChanged: this.novaSituacaoAlterada,
    };

    this.motivoSituacaoOptions = {
      editorType: "dxSelectBox",
      searchEnabled: true,
      dataSource: this.motivosDs,
      valueExpr: "id",
      displayExpr: "descricao",
      placeholder: " ",
    };

    this.agenteRecebedorOptions = {
      searchEnabled: true,
      dataSource: criarAgentesRecebedoresDs(),
      valueExpr: "id",
      displayExpr: "descricao",
      placeholder: " ",
    };

    this.setStateSync = this.setStateSync.bind(this);
  }


  setStateSync(state) {
    return new Promise(resolve => {
      this.setState(state, resolve)
    })
  }

  novaSituacaoAlterada(e) {
    if (e.event) {
      this.setState({ situacao: e.value });
    }
  }

  componentDidMount() {
    this.atualizarTela();
  }

  atualizarTela() {
    if (this.lancamentoSequencial !== undefined) {
      api
        .get(
          `/lancamentos/start_detalhe_lancamento/${this.prefeituraId}/${this.lancamentoSequencial}`
        )
        .then(async ({ data }) => {
          if (data) {
            console.log(data);
            let novoEstado;
            const lancamento = data.lancamento;

            try {
              novoEstado = {
                ...lancamento,
                _uiPossuiContribuinte: !!lancamento.contribuinte,
                _uiPossuiCpbs: !!lancamento.cpbsLancamento,
                _uiPossuiVeiculo: !!lancamento.veiculo,
                _uiPossuiImovel: !!lancamento.imovel,
                _uiContribuinte: !lancamento.contribuinte
                  ? ""
                  : `${lancamento.contribuinte.sequencial} - ${lancamento.contribuinte.nome}`,
                _uiCpbs: !lancamento.cpbsLancamento
                  ? ""
                  : `${lancamento.cpbsLancamento.inscricao} - ${lancamento.cpbsLancamento.contribuinte.nome}`,
                _uiImovel: !lancamento.imovel
                  ? ""
                  : `${lancamento.imovel.sequencial} - ${lancamento.imovel.cartografiaFormatada} - ${lancamento.imovel.enderecoCompleto}`,
                _uiVeiculo: !lancamento.veiculo
                  ? ""
                  : `${lancamento.veiculo.placa} - ${lancamento.veiculo.descricaoCompleta}`,
                modificarSituacao: {
                  novaSituacao: null,
                  motivoId: null,
                },
                baixa: {
                  parcela: null,
                  dataPagamento: null,
                  dataCredito: null,
                  valor: null,
                },
              };

              novoEstado.tipo.imposto = novoEstado.tipo.imposto.toUpperCase();
              novoEstado.parcelas = novoEstado.parcelas.filter(
                (x) => novoEstado.situacaoStr !== "N" || !x.excluida
              );

              if (novoEstado._uiPossuiCpbs) {
                novoEstado._uiPossuiContribuinte = false;
              }

              novoEstado.usaPix = data.usaPix;
              novoEstado.pixOk = data.pixOk;
              novoEstado.locadIndicatorVisivel = data.usaPix && !data.pixOk ? 1 : 0;

              await this.setStateSync(novoEstado);

              console.log("dataPx", data);

              if (novoEstado.locadIndicatorVisivel == 1) {

                let isPixLoaded = false;

                while (!isPixLoaded && !this.state.pixIgnorado && this.state.locadIndicatorVisivel == 1) {
                  try {
                    let { data } = await api.get(
                      `/lancamentos/start_detalhe_lancamento/${this.prefeituraId}/${this.lancamentoSequencial}`
                    );
                    if (data && data.pixOk && !this.state.pixIgnorado) {
                      isPixLoaded = data.pixOk;
                      novoEstado.usaPix = data.usaPix;
                      novoEstado.pixOk = data.pixOk;
                      novoEstado.locadIndicatorVisivel = data.usaPix && !data.pixOk ? 1 : 0;
                    }
                  } catch (_) { }

                  await this.timeoutWait();
                }
              }
            } catch (error) {
              console.log(error);
            }

            if (this.state.locadIndicatorVisivel == 1) {
              this.setState(novoEstado);
            }
          } else {
            notify("Lançamento não encontrado.", "error");
            this.props.history.push("/home");
          }
        })
        .catch((error) => {
          ShowError(error.response);
          notify(error, "error", 2000);
          this.props.history.goBack();
        });
    }
  }

  timeoutWait() {
    return new Promise((resolve) => setTimeout(resolve, 2000));
  }

  render() {
    if (this.state.locadIndicatorVisivel != 0) {
      return (
        <div className={"content-block dx-card responsive-paddings"}>

          <div
            style={{
              display: "flex",
              marginTop: "25px",
              justifyContent: "center",
              alignContent: "center",
              justifyItems: "center",
              alignItems: "center",
              gap: "25px",
            }}
          >
            <LoadIndicator width={60} height={60} />
            <h3
              style={{
                display: this.state.locadIndicatorVisivel == 1 ? "" : "none",
              }}
            >
              Consultando PIX
            </h3>
            <h3
              style={{
                display: this.state.locadIndicatorVisivel == 2 ? "" : "none",
              }}
            >
              Consultando Pagamento Pix
            </h3>
          </div>
          <div
            style={{
              display: this.state.locadIndicatorVisivel != 0 ? "flex" : "none",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Button
              width={120}
              text="Ignorar PIX"
              onClick={() => this.setState({ locadIndicatorVisivel: 0, usaPix: false, pixIgnorado: true })}
              visible={this.state.locadIndicatorVisivel == 1}
            />

            <Button
              width={250}
              text="Cancelar Consulta"
              onClick={() => this.setState({ locadIndicatorVisivel: 0, consultandoPagamento: false })}
              disabled={!this.state.usaPix}
              visible={this.state.locadIndicatorVisivel == 2}
            />
          </div>
        </div>
      );
    }

    return (
      <React.Fragment>
        {console.log("state", this.state.parcelas)}
        <div className={"content-block dx-card responsive-paddings"}>
          <Toolbar>
            <Item
              location="left"
              locateInMenu="auto"
              widget="dxButton"
              options={{
                text: "Voltar",
                icon: "arrowleft",
                onClick: () => this.props.history.goBack(),
              }}
            />

            <Item
              location="right"
              locateInMenu="auto"
              widget="dxButton"
              options={{
                visible: false,
                text: "Espelho",
                onClick: () => this.espelho(),
              }}
            />

            <Item
              location="after"
              locateInMenu="auto"
              widget="dxButton"
              options={{
                text: "DAM",
                icon: "exportpdf",
                width: 150,
                onClick: () => this.dam(),
              }}
            />

            <Item
              location="after"
              locateInMenu="auto"
              widget="dxButton"
              options={{
                text: "DAM Pix",
                icon: pixIcon,
                width: 150,
                visible: this.state.usaPix ? true : false,
                onClick: () => this.dam(this.state.usaPix),
              }}
            />

            <Item
              location="after"
              locateInMenu="auto"
              widget="dxButton"
              options={{
                text: "Confirmar Pix",
                icon: "todo",
                width: 150,
                visible: this.state.usaPix ? true : false,
                onClick: () => this.confirmarPix(),
              }}
            />

            <Item
              location="after"
              locateInMenu="auto"
              widget="dxButton"
              options={{
                text: "Documento",
                icon: "doc",
                width: 150,
                onClick: () => this.documento(),
              }}
            />

            <Item
              location="after"
              locateInMenu="auto"
              widget="dxButton"
              options={{
                width: 150,
                icon: "edit",
                text: "Editar",
                onClick: () => this.editar(),
              }}
            />
          </Toolbar>
          <br />
          <form>
            <Form formData={this.state} className="readOnlyBGless" colCount={2}>
              <GroupItem
                caption={"DADOS DO LANÇAMENTO"}
                colSpan={2}
                colCount={6}
              >
                <SimpleItem
                  colSpan={6}
                  dataField={"sequencial"}
                  editorOptions={{ readOnly: true }}
                >
                  <Label text="Cód. Lancamento" />
                </SimpleItem>

                <SimpleItem
                  colSpan={6}
                  dataType={"date"}
                  dataField={"dataLancamento"}
                  editorType={"dxDateBox"}
                  editorOptions={{ width: "100%", readOnly: true }}
                >
                  <Label text="Data" />
                </SimpleItem>

                <SimpleItem
                  colSpan={6}
                  dataField={"receita.descricao"}
                  editorOptions={{ width: "100%", readOnly: true }}
                >
                  <Label text="Tipo de Lançamento" />
                </SimpleItem>

                <SimpleItem
                  colSpan={6}
                  visible={this.state_uiPossuiContribuinte}
                  dataField={"_uiContribuinte"}
                  editorOptions={{ readOnly: true }}
                >
                  <Label text="Contribuinte" />
                </SimpleItem>

                <SimpleItem
                  colSpan={6}
                  visible={this.state._uiPossuiImovel}
                  dataField={"_uiImovel"}
                  editorOptions={{ readOnly: true }}
                >
                  <Label text="Imóvel" />
                </SimpleItem>

                <SimpleItem
                  colSpan={6}
                  visible={this.state._uiPossuiImovel}
                  dataField={"_uiVeiculo"}
                  editorOptions={{ readOnly: true }}
                >
                  <Label text="Veículo" />
                </SimpleItem>
              </GroupItem>
            </Form>
            <br />
            <DataGrid
              dataSource={this.state.parcelas}
              showBorders={true}
              rowAlternationEnabled={true}
              columnAutoWidth={true}
              columnHidingEnabled={true}
              wordWrapEnabled={window.innerWidth < 800}
              filterSyncEnabled={true}
            >
              <Column
                alignment={"center"}
                dataField={"sequencial"}
                caption={"DAM"}
                width={120}
              />

              <Column
                alignment={"center"}
                dataField={"numeroDaParcela"}
                caption={"Parcela"}
                width={80}
              />

              <Column
                alignment={"center"}
                dataField={"dataDeVencimento"}
                caption={"Vencimento"}
                dataType="date"
                width={120}
                sortIndex={1}
                sortOrder={"asc"}
              />

              <Column
                dataField={"valorTotal"}
                dataType={"number"}
                caption={"Valor (R$)"}
                format={uiInfo.formatoNumerico.n2}
                width={150}
              />

              <Column
                dataField={"situacaoPagto"}
                caption={"Situação"}
                width={200}
              />

              <Column dataField={"descricao"} caption={"Descrição"} />
              <Column dataField={"excluida"} caption={"Excluída"} width={80} />

              <Summary>
                <TotalItem
                  column="valor"
                  summaryType="sum"
                  displayFormat={"Total (R$): {0}"}
                  valueFormat={uiInfo.formatoNumerico.n2}
                />
              </Summary>
              <Paging defaultPageSize={uiInfo.tamanhoPaginaPadrao} />
              <Pager
                showPageSizeSelector={true}
                allowedPageSizes={uiInfo.tamanhoPaginaOpcoes}
              />
            </DataGrid>
            <br />
            <br />
            <div
              style={{
                marginTop: "10px",
                display: "flex",
                justifyContent: "center",
              }}
            >
              <div
                style={{
                  display: "inline-block",
                  marginRight: "10px",
                  justifyContent: "center",
                  width: "100%",
                }}
              >
                <Form formData={this.state}>
                  <GroupItem caption={"BAIXA MANUAL"} colSpan={1} colCount={4}>
                    <SimpleItem colSpan={2} dataField={"baixa.damSequencial"}>
                      <Label text="DAM" />
                    </SimpleItem>

                    <EmptyItem colSpan={2} />

                    <SimpleItem
                      colSpan={4}
                      dataField={"baixa.agenteRecebedorId"}
                      editorType={"dxSelectBox"}
                      editorOptions={this.agenteRecebedorOptions}
                    >
                      <Label text="Ag. Recebedor" />
                    </SimpleItem>

                    <SimpleItem
                      colSpan={2}
                      dataField={"baixa.dataPagto"}
                      dataType={"date"}
                      editorType={"dxDateBox"}
                      editorOptions={{ width: "100%", useMaskBehavior: true }}
                    >
                      <Label text="Dt. Pagamento" />
                    </SimpleItem>

                    <SimpleItem
                      colSpan={2}
                      dataField={"baixa.dataCredito"}
                      dataType={"date"}
                      editorType={"dxDateBox"}
                      editorOptions={{ width: "100%", useMaskBehavior: true }}
                    >
                      <Label text="Dt. Crédito" />
                    </SimpleItem>

                    <SimpleItem
                      colSpan={2}
                      dataField={"baixa.valorPago"}
                      editorType={"dxNumberBox"}
                      cssClass="box-n2"
                      editorOptions={{
                        format: uiInfo.formatoNumerico.n2,
                      }}
                    >
                      <Label text="Valor" />
                    </SimpleItem>

                    <EmptyItem colSpan={2} />

                    <EmptyItem />

                    <ButtonItem
                      buttonOptions={{
                        text: "BAIXAR",
                        type: "success",
                        onClick: this.baixarParcela,
                        width: "100%",
                        hint: "Realiza a baixa do DAM informado",
                      }}
                      alignment={"center"}
                    />

                    <ButtonItem
                      buttonOptions={{
                        text: "EXCLUIR",
                        type: "default",
                        onClick: this.excluirBaixa,
                        width: "100%",
                        hint: "Exclui a baixa do DAM informado",
                      }}
                      alignment={"center"}
                    />
                  </GroupItem>
                </Form>
              </div>
              <div
                style={{
                  display: "inline-block",
                  marginLeft: "10px",
                  justifyContent: "center",
                  width: "100%",
                }}
              >
                <Form
                  formData={this.state}
                  colCount={1}
                  className={"readOnlyBGless"}
                >
                  <GroupItem caption={"SITUAÇÃO"} colSpan={1} colCount={4}>
                    <SimpleItem
                      colSpan={4}
                      dataField={"_uiModificarSituacao.novaSituacao"}
                      editorType={"dxSelectBox"}
                      editorOptions={this.situacaoOptions}
                    >
                      <Label text="Nova Situação" />
                    </SimpleItem>

                    <SimpleItem
                      colSpan={4}
                      dataField={"_uiModificarSituacao.motivoId"}
                      editorType={"dxLookup"}
                      editorOptions={{
                        ...this.motivoSituacaoOptions,
                        readOnly:
                          this.state._uiModificarSituacao.novaSituacao === "N"
                            ? true
                            : false,
                      }}
                    >
                      <Label text="Motivo" />
                    </SimpleItem>

                    <EmptyItem colSpan={4} />
                    <EmptyItem colSpan={4} />
                    <EmptyItem colSpan={4} />
                    <EmptyItem colSpan={4} />

                    <EmptyItem />
                    <ButtonItem
                      colSpan={2}
                      buttonOptions={{
                        text: "MODIFICAR SITUAÇÃO",
                        type: "success",
                        onClick: this.modificarSituacao,
                        width: "100%",
                      }}
                      alignment={"center"}
                    />
                  </GroupItem>
                </Form>
              </div>
            </div>
          </form>
        </div>
      </React.Fragment>
    );
  }

  baixarParcela() {
    const entidade = this.state.baixa;
    entidade.tipoBaixa = 1;
    entidade.prefeituraId = this.prefeituraId;
    api
      .post("dam/baixa_manual/", this.state.baixa)
      .then(() => {
        this.setState({
          baixa: {
            damSequencial: null,
            agenteRecebedorId: null,
            dataPagto: null,
            dataCredito: null,
            valorPago: null,
          },
        });
        this.atualizarTela();
      })
      .catch((error) => {
        ShowError(error.response.data);
      });
  }

  excluirBaixa() {
    if (this.state.baixa == undefined) {
      ShowError("Informe o código do DAM");
      return;
    }

    var entidade = {
      tipoBaixa: 1,
      prefeituraId: this.prefeituraId,
      damSequencial: this.state.baixa.damSequencial,
    };

    api
      .post("dam/excluir_baixa_manual/", entidade)
      .then(() => {
        this.setState({
          baixa: {
            damSequencial: null,
            agenteRecebedorId: null,
            dataPagto: null,
            dataCredito: null,
            valorPago: null,
          },
        });
        this.atualizarTela();
      })
      .catch((error) => {
        if (error.response && error.response.data) {
          ShowError(error.response.data);
        } else {
          ShowError(error.message);
        }
      });
  }

  modificarSituacao() {
    const entidade = {
      prefeituraId: this.prefeituraId,
      sequencialLancamento: this.state.sequencial,
      novaSituacao: this.state._uiModificarSituacao.novaSituacao,
      motivoId: this.state._uiModificarSituacao.motivoId,
    };

    api
      .post("dam/mudar_situacao_lancamento/", entidade)
      .then(() => {
        this.setState({
          _uiModificarSituacao: {
            tipo: null,
            novaSituacao: "N",
            motivoId: null,
          },
        });
        this.atualizarTela();
      })
      .catch((error) => {
        if (error.response && error.response.data) {
          ShowError(error.response.data);
        } else {
          ShowError("Erro desconhecido");
        }
      });
  }

  editar() {
    abrirLancamento(this.props.history, this.state);
  }

  espelho() {
    alert("Espelho clicado");
  }

  dam(imprimePix = false) {
    imprimirDam(this.state, imprimePix);
  }

  async confirmarPix() {
    this.setState({ locadIndicatorVisivel: 2 });
    console.log(this.state);
    api
      .get(
        `/lancamentos/consultar_pagamento_pix/${this.prefeituraId}/${this.lancamentoSequencial}`
      )
      .then(({ data }) => {
        if (this.state.locadIndicatorVisivel == 2) {
          const lancamento = data.lancamento;
          if (lancamento) {
            this.setState({ ...lancamento, locadIndicatorVisivel: 0 });
          }
        }

      })
      .catch((error) => {
        if (error.response && error.response.data) {
          ShowError(error.response.data);
        } else {
          ShowError("Erro desconhecido");
        }
      });
  }

  documento() {
    console.log("estado component", this.state)
    imprimirAlvara(this.state.tipoStr, this.state.id);
  }
}
